import ENVIRONMENT from "../../../config/environment";
import React, { useEffect, useState } from "react";
import googlePlay from "../../../assets/img/GooglePlay.svg";
import tiktokIcon from "../../../assets/img/tiktokIcon.svg";
import twitterIcon from "../../../assets/img/xIcon.svg";
import snapchatIcon from "../../../assets/img/snapchatIcon.svg";
import fbIcon from "../../../assets/img/fbIcon.svg";
import instaIcon from "../../../assets/img/instaIcon.svg";
import YtIcon from "../../../assets/img/ytIcon.svg";
import logo from "../../../assets/img/posLogo.svg";
import { i18n } from "../private/languageSelector";
import sendIcon from "../../../assets/img/sendEmailIcon.svg";
import { useLocation } from "react-router-dom";
import ContactModal from "./components/ContactModal";
import { useHistory } from "react-router-dom";
import { GOOGLE_PLAY_URL, socialLinks } from "../../../helpers/constants";
import { trackAppClick } from "../../../helpers/analyticsTracking";

const HomeFooter = () => {
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [showContactModal, setShowContactModal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const selectedLanguage = localStorage.getItem("language");
  const location = useLocation();
  const showPricing = location.state?.showPricing || false;
  const handleHideContactModal = () => {
    setShowContactModal(false);
  };
  const handleShowContactModal = () => {
    setShowContactModal(true);
  };
  const history = useHistory();
  const serverBaseUrl = ENVIRONMENT.serverUrl;

  const handlePosDownloadClick = () => {
    trackAppClick();
  };
  return (
    <div>
      <div className="newsLetter">
        <div
          className="started-header  pt-3"
          style={{ alignItems: "center", marginTop: !showPricing && "4.5rem", padding: screenSize < 1074 ? "12px 25px" : "" }}
        >
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div
              style={{
                display: screenSize < 672 ? "" : "flex",
                justifyContent: screenSize < 1074 ? "" : "space-between",
                flexDirection: selectedLanguage === "arabic" ? "row-reverse" : "row",
              }}
            >
              <div className="pr-0 mt-4">
                <div className="media_links " style={{ margin: "21px 0" }}>
                  <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" onClick={handlePosDownloadClick}>
                    <img width={"138px"} src={googlePlay} alt="google_play" />
                  </a>
                </div>
              </div>
              {screenSize < 672 ? null : (
                <div className=" mt-4 pl-0 terms-info">
                  <div style={{ textAlign: selectedLanguage === "arabic" ? "right" : "left" }}>
                    <p style={{ color: "white", fontWeight: "400", fontSize: "16px", lineHeight: "21px" }}>{i18n("HomePage.FatoratyByNumu")}</p>
                    <p style={{ color: "white", fontWeight: "400", fontSize: "16px", lineHeight: "21px" }}>{i18n("HomePage.SaudiArabia")}</p>
                    <p style={{ color: "white", fontWeight: "400", fontSize: "16px", lineHeight: "21px" }}>info@fatoraty.com</p>
                  </div>
                </div>
              )}

              <div className="footer-input mt-4" style={{ width: screenSize < 672 ? "100%" : "280px" }}>
                <div>
                  <p
                    style={{
                      color: "white",
                      fontWeight: "400",
                      fontSize: "16px",
                      lineHeight: "21px",
                      textAlign: screenSize < 672 ? "center" : selectedLanguage === "arabic" ? "right" : "left",
                    }}
                  >
                    {i18n("HomePage.SubscribeToOurNewsLetter")}
                  </p>
                  <div>
                    <div className="input-group relative" style={{ direction: selectedLanguage === "arabic" ? "rtl" : "ltr" }}>
                      <input
                        type="text"
                        className="form-control"
                        style={{ paddingLeft: selectedLanguage === "arabic" && "3rem", paddingRight: selectedLanguage === "english" && "3rem" }}
                        placeholder={i18n("HomePage.EmailAddress")}
                      />
                      {/* <div class="input-group-btn">
                        <button class="btn btn-default" type="submit">
                          <i class="glyphicon glyphicon-search"></i>
                        </button>
                      </div> */}
                      <div
                        style={{
                          position: "absolute",
                          // left: "2rem",
                          zIndex: "100",
                          top: "9px",
                          left: selectedLanguage === "arabic" && "1rem",
                          right: selectedLanguage === "english" && "1rem",
                        }}
                      >
                        {" "}
                        <img src={sendIcon} alt="send" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: "1300px", margin: "0 auto", marginBottom: "3.5rem", padding: "0 18px", textAlign: "start" }}>
        <div
          className="footer-wrapper1"
          style={{ justifyContent: "space-between", flexDirection: selectedLanguage === "arabic" ? "row-reverse" : "row" }}
        >
          <div style={{ marginTop: "2.8rem", paddingLeft: "0" }}>
            <div className="d-flex" style={{ gap: "20px", flexDirection: selectedLanguage === "arabic" ? "row-reverse" : "row" }}>
              <a
                style={{ color: "#4F4F4F", fontWeight: "500", fontSize: "16px", lineHeight: "21px" }}
                href={`${serverBaseUrl}terms-and-conditions?lang=${selectedLanguage}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n("HomePage.TermsAndConditions")}
              </a>
              <a
                style={{ color: "#4F4F4F", fontWeight: "500", fontSize: "16px", lineHeight: "21px" }}
                href={`${serverBaseUrl}privacy-policy?lang=${selectedLanguage}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {i18n("login.PrivacyPolicy")}
              </a>
              <p
                className="cursor-pointer"
                style={{ color: "#4F4F4F", fontWeight: "500", fontSize: "16px", lineHeight: "21px" }}
                onClick={handleShowContactModal}
              >
                {i18n("HomePage.Contact")}
              </p>
              <p
                className="cursor-pointer"
                onClick={() => history.push("/help")}
                style={{ color: "#4F4F4F", fontWeight: "500", fontSize: "16px", lineHeight: "21px" }}
              >
                {i18n("HomePage.Help")}
              </p>
            </div>
          </div>
          <div style={{ marginTop: "2.2rem", marginLeft: "100px" }}>
            <img width={"160px"} src={logo} alt="logo" />
          </div>
          <div style={{ marginTop: "2.8rem", marginLeft: "200px" }}>
            <div className="d-flex justify-content-center" style={{ gap: "30px" }}>
              <a href={socialLinks.snapchat} target="_blank" rel="noopener noreferrer">
                <img src={snapchatIcon} alt="snapchat" />
              </a>
              <a href={socialLinks.x} target="_blank" rel="noopener noreferrer">
                <img src={twitterIcon} alt="twitter" rel="noopener noreferrer" />
              </a>
              <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                <img src={fbIcon} alt="facebook" />
              </a>
              <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                <img src={instaIcon} alt="instagram" />
              </a>
              <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                <img src={YtIcon} alt="youtube" />
              </a>
              <a href={socialLinks.tiktok} target="_blank" rel="noopener noreferrer">
                <img src={tiktokIcon} alt="tiktok" />
              </a>
            </div>
          </div>
        </div>
        {screenSize < 1074 ? (
          <div className="footer-wrapper2 mt-5 mb-5">
            <div className="term-condition">
              <div className={`row ${selectedLanguage === "arabic" ? "text-right rtl" : "text-left ltr"}`}>
                <div className="col-6">
                  <div className="mb-4">
                    <a
                      style={{ color: "#4F4F4F" }}
                      href={`${serverBaseUrl}terms-and-conditions?lang=${selectedLanguage}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n("HomePage.TermsAndConditions")}
                    </a>
                  </div>
                  <div className="mb-4">
                    <a
                      style={{ color: "#4F4F4F" }}
                      href={`${serverBaseUrl}privacy-policy?lang=${selectedLanguage}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {i18n("login.PrivacyPolicy")}
                    </a>
                  </div>
                  <p className="cursor-pointer" style={{ color: "#4F4F4F" }} onClick={() => history.push("/help")}>
                    {i18n("HomePage.Help")}
                  </p>
                  <p className="cursor-pointer" style={{ color: "#4F4F4F" }} onClick={handleShowContactModal}>
                    {i18n("HomePage.Contact")}
                  </p>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center mt-5" style={{ gap: "30px" }}>
              <a href={socialLinks.snapchat} target="_blank" rel="noopener noreferrer">
                <img src={snapchatIcon} alt="snapchat" />
              </a>
              <a href={socialLinks.x} target="_blank" rel="noopener noreferrer">
                <img src={twitterIcon} alt="twitter" />
              </a>
              <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                <img src={fbIcon} alt="facebook" />
              </a>
              <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                <img src={instaIcon} alt="instagram" />
              </a>
              <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                <img src={YtIcon} alt="youtube" />
              </a>
              <a href={socialLinks.tiktok} target="_blank" rel="noopener noreferrer">
                <img src={tiktokIcon} alt="tiktok" />
              </a>
            </div>
            <div className="d-flex justify-content-center" style={{ marginTop: "30px" }}>
              <img className="home-logo" width={"160px"} src={logo} alt="logo" />
            </div>
            <p style={{ fontSize: "14px", color: "#828282" }} className="text-center mt-5">
              {/* ©Fatoraty 2023 by Numu Technologies */}
              {i18n("HomePage.FatoratyByNumu")}
            </p>
          </div>
        ) : null}
      </div>
      <ContactModal show={showContactModal} onHide={handleHideContactModal} />
    </div>
  );
};

export default HomeFooter;
